import type { DashboardOverviewDto } from '@aiai/shared';
import { planetNeedsYou } from './needsYou';
import type { TvCue } from './tvDirector';

/**
 * TV distress cues from two overview snapshots (the only source of "a planet newly needs you"):
 * a planet that needs you now and did not in `prev`, or whose failed-issue count grew (an issue
 * gave up). Nothing fires without a previous snapshot.
 */
export function snapshotCues(
  prev: DashboardOverviewDto | undefined,
  next: DashboardOverviewDto,
  now: number,
): TvCue[] {
  if (!prev) return [];
  const cues: TvCue[] = [];
  const before = new Map(prev.planets.map((p) => [p.id, p]));
  for (const p of next.planets) {
    const was = before.get(p.id);
    if (!was) continue;
    if ((!planetNeedsYou(was) && planetNeedsYou(p)) || p.failedIssueCount > was.failedIssueCount) {
      cues.push({ kind: 'distress', projectId: p.id, at: now });
    }
  }
  return cues;
}
